import * as actions from './actions';
import * as reactions from './reactions';
import * as reducers from './reducers';
import * as selectors from './selectors';

export * from './constants';

export default {
  name: 'organizations',
  ...actions,
  ...reactions,
  ...reducers,
  ...selectors,
};
